module.exports = __webpack_public_path__ + "static/media/bg-auth-full.1cc7308c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-auth-full.jpg
// module id = ./src/assets/img/bg-auth-full.jpg
// module chunks = 11